import React from 'react'
import Card from 'react-bootstrap/Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { getIcon } from 'shared/icons'
import { getDatasetDescription } from './section-descriptions'

function ModuleCardIcon({ section, setParams, params }) {
  const icon = getIcon(section.abbreviation)
  const active = params.section_id === section.id
  const description = getDatasetDescription(section.abbreviation)

  return (
    <Card
      className={'shadow-sm h-100'}
      style={{
        cursor: 'pointer',
        background: active ? '#f0f5f7' : '',
        border: active ? '1px solid #6ea0b5' : ''
      }}
      onClick={(e) =>
        setParams({
          ...params,
          section_id: section.id,
          includedAnalytics: []
        })
      }
    >
      <Card.Body>
        {active ? (
          <span>
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="text-primary ms-1"
            />
          </span>
        ) : (
          <span>
            {' '}
            <FontAwesomeIcon icon={faCheckCircle} className="text-white ms-1" />
          </span>
        )}
        <div className="d-flex justify-content-center">
          <img
            src={icon}
            className="img-fluid"
            style={{ height: '35px' }}
            alt={section?.unit || section.name}
          />
        </div>
        <div className="d-flex justify-content-center">
          <Card.Text className="fw-lighter my-2 text-center">
            {section?.unit || section.name}
          </Card.Text>
        </div>
        {description && (
          <Card.Text className="text-muted small text-center mb-0">
            {description}
          </Card.Text>
        )}
      </Card.Body>
    </Card>
  )
}

export default ModuleCardIcon
